import React, { useState, useEffect } from "react";
import { Col, Row, Button } from "react-bootstrap";
import OldSalesForm from "./OldForm";
import SchemeSalesForm from "./SchemesForm";
import SaleReturnForm from "./SaleReturnForm"; // Import the SaleReturnForm component
import { useNavigate } from "react-router-dom";
import './SalesForm3section.css';
import Repairtable from "./SalesRepairTable";
import Oderstable from "./SalesOrderTable";
const SalesFormSection = ({ setOldSalesData,
  oldTableData,
  setOldTableData,
  setSchemeSalesData,
  selectedMobile,
  invoiceDetails,
  filteredInvoices,
  setFilteredInvoices,
  uniqueInvoice,
  handleInvoiceChange,
  setReturnData,
  returnData,
  selectedRows,
  setSelectedRows,
  isAllSelected,
  setIsAllSelected,
  handleCheckboxChange,
  handleSelectAllChange,
  salesTaxableAmount,
  salesTaxAmount,
  salesNetAmount,
  repairDetails,
  resetSaleReturnForm,
  handleCheckout,
  tabId,
  setRepairDetails,
  formData,
  orderData,
  handleCloseModal,
  handleViewDetails,
  handleOrderCheckboxChange,
  selectedOrder,
  showModal,
  orderDetails,
  loading,
  formatDate,
  repairs,
  handleRepairCheckboxChange,
  salesReturnData,
  estimateNumber,
  resetActiveForm
}) => {

  const [activeForm, setActiveForm] = useState(() => {
    const savedActiveForm = localStorage.getItem(`activeForm_${tabId}`);
    return savedActiveForm || "old";
  });
  
  const navigate = useNavigate();

  // Save activeForm to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem(`activeForm_${tabId}`, activeForm);
  }, [activeForm, tabId]);

  // Reset activeForm when resetActiveForm prop changes
  useEffect(() => {
    if (resetActiveForm) {
      // Force switch to a different tab first, then back to URD purchase
      setActiveForm("schemes");
      setTimeout(() => {
        setActiveForm("old");
        localStorage.removeItem(`activeForm_${tabId}`);
      }, 50);
    }
  }, [resetActiveForm, tabId]);
  

  return (
    <Col className="sales-form-section">
      <Row style={{ height: "45px" }}>
        <Col xs={12} className="mb-3">
          <Button
            style={{
              backgroundColor: activeForm === "old" ? "rgb(163, 110, 41)" : "gray",
              borderColor: activeForm === "old" ? "rgb(163, 110, 41)" : "gray",
              color: "white", fontSize: '13px', padding: '5px'
            }}
            onClick={() => setActiveForm("old")}
          >
            URD Purchase
          </Button>
          <Button
            style={{
              backgroundColor: activeForm === "schemes" ? "rgb(163, 110, 41)" : "gray",
              borderColor: activeForm === "schemes" ? "rgb(163, 110, 41)" : "gray",
              color: "white", fontSize: '13px', padding: '5px'
            }}
            onClick={() => setActiveForm("schemes")}
            className="ms-2"
          >
            Schemes
          </Button>
          <Button
            style={{
              backgroundColor: activeForm === "sale_return" ? "rgb(163, 110, 41)" : "gray",
              borderColor: activeForm === "sale_return" ? "rgb(163, 110, 41)" : "gray",
              color: "white", fontSize: '13px', padding: '5px'
            }}
            onClick={() => setActiveForm("sale_return")}
            className="ms-2"
          >
            Sale Return
          </Button>
          <Button
            style={{
              backgroundColor: activeForm === "orders" ? "rgb(163, 110, 41)" : "gray",
              borderColor: activeForm === "orders" ? "rgb(163, 110, 41)" : "gray",
              color: "white", fontSize: '13px', padding: '5px'
            }}
            onClick={() => {
              setActiveForm("orders");
            }}
            className="ms-2"

          >
            Orders
          </Button>
          <Button
            style={{
              backgroundColor: activeForm === "repair" ? "rgb(163, 110, 41)" : "gray",
              borderColor: activeForm === "repairs" ? "rgb(163, 110, 41)" : "gray",
              color: "white", fontSize: '13px', padding: '5px'
            }}

            onClick={() => {
              setActiveForm("repair");
            }}
            className="ms-2"
          >
            Repairs
          </Button>
        </Col>

      </Row>

      {activeForm === "old" && <OldSalesForm setOldSalesData={setOldSalesData} oldTableData={oldTableData} setOldTableData={setOldTableData} repairDetails={repairDetails} tabId={tabId} />}
      {activeForm === "schemes" && (
        <SchemeSalesForm
          setSchemeSalesData={setSchemeSalesData}
          selectedMobile={selectedMobile} // Pass the selected mobile number
          tabId={tabId}
        />
      )}
      {activeForm === "orders" && (
        <Oderstable
          selectedMobile={selectedMobile}
          tabId={tabId}
          setRepairDetails={setRepairDetails}
          formData={formData}
          repairDetails={repairDetails}
          orderData={orderData}
          handleCloseModal={handleCloseModal}
          handleViewDetails={handleViewDetails}
          selectedOrder={selectedOrder}
          handleOrderCheckboxChange={handleOrderCheckboxChange}
          showModal={showModal}
          orderDetails={orderDetails}
          loading={loading}
          formatDate={formatDate}
        />
      )}
      {activeForm === "repair" && (
        <Repairtable
          selectedMobile={selectedMobile}
          repairs={repairs}
          tabId={tabId}
          setRepairDetails={setRepairDetails}
          handleRepairCheckboxChange={handleRepairCheckboxChange}
          formData={formData}
        />
      )}
      {activeForm === "sale_return" && <SaleReturnForm
        invoiceDetails={invoiceDetails}
        filteredInvoices={filteredInvoices}
        setFilteredInvoices={setFilteredInvoices}
        uniqueInvoice={uniqueInvoice}
        handleInvoiceChange={handleInvoiceChange}
        returnData={returnData}
        setReturnData={setReturnData}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        isAllSelected={isAllSelected}
        setIsAllSelected={setIsAllSelected}
        handleCheckboxChange={handleCheckboxChange}
        handleSelectAllChange={handleSelectAllChange}
        salesTaxableAmount={salesTaxableAmount}
        salesTaxAmount={salesTaxAmount}
        salesNetAmount={salesNetAmount}
        resetSaleReturnForm={resetSaleReturnForm}
        handleCheckout={handleCheckout}
        salesReturnData={salesReturnData}
        estimateNumber={estimateNumber}
      />} {/* Render SaleReturnForm */}
    </Col>
  );
};

export default SalesFormSection;
